import BundleProductPrice from "../../../entities/manhattan/bundle/BundleProductPrice";
import { dividePrice } from "../../../utilites/util";

export default class BundleProductPriceFactory {

  static create(bundleProductPrice: BundleProductPrice): BundleProductPrice {
    return new BundleProductPrice(
      bundleProductPrice.id,
      dividePrice(bundleProductPrice.price),
      bundleProductPrice.type
    );
  }

}
